module.exports = __webpack_public_path__ + "img/06318618000342.b92d10c8.png";